/** @typedef {{ name: string; id: string; previewImage: string; data: string }} Layout */

/**
 * @returns {Layout[]}
 */
export function getSingleListingLayouts() {
	return [
		{
			name: 'Stacked Layout',
			id: 'stacked',
			previewImage: 'https://placehold.co/200x150/e1e1e1/666666?text=Stacked+Layout',
			data: String.raw`
				<style type="text/css">
  @media only screen and (max-width: 640px) {
    .single-listing-stacked-image-col {
			display: table !important;
      max-width: none !important;
      min-width: 0 !important;
      float: none !important;
      margin: 0 auto !important;
    }

    .single-listing-stacked-image {
      display: block !important;
      width: 100% !important;
      max-width: none !important;
      height: auto !important;
      margin: 0 auto !important;
    }

    .single-listing-stacked-content {
			display: table !important;
			text-align: center !important;
      max-width: none !important;
      float: none !important;
      margin: 0 auto !important;
    }

    .single-listing-stacked-body {
      padding: 10px 0 0 0 !important;
      text-align: center !important;
    }

    .single-listing-stacked-button {
      margin: 0 auto !important;
    }
  }
</style>
<!--[if mso]>
<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="max-width: 600px;">
<tr>
<![endif]-->
<table class="{{cssClasses}}"{{{listingRefAttr}}} role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%"
  style="max-width: 600px; margin: 0 auto; background-color: {{backgroundColor}}; font-size: 14px;">
  <tr>
    <td style="padding: {{padding}}; vertical-align: middle; font-size: 14px; line-height: normal;">{{#each listings}}
      <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%"
        style="max-width: 600px; background-color: #ffffff; border: 1px solid #e0e0e0; border-radius: 8px; margin: 0; overflow: hidden;">
        <tr>
          <td style="padding: 15px; font-size: 0; text-align: center;">
            <!--[if mso]>
<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
<tr>
<td valign="top" width="200">
<![endif]-->
            <table class="single-listing-stacked-image-col" role="presentation" cellspacing="0" cellpadding="0"
              border="0" width="240" align="center"
              style="width: 240px; min-width: 240px; max-width: 240px; display: inline-block; vertical-align: top;">
              <tr>
                <td style="font-size: 14px;">
                  <a href="{{../href}}" style="display: block; text-decoration: none;">
                    <img class="single-listing-stacked-image" src="{{{{raw}}}}{{imagePath}}{{{{/raw}}}}"
                      alt="Listing Image" width="240"
                      style="width: 100%; max-width: 240px; height: auto; border-radius: 8px; display: block;" />
                  </a>
                </td>
              </tr>
            </table>
            <!--[if mso]>
</td>
<td valign="top" width="20" style="font-size: 1px; line-height: 1px;">&nbsp;</td>
<td valign="top" width="320">
<![endif]-->
            <table class="single-listing-stacked-content" role="presentation" cellspacing="0" cellpadding="0" border="0"
              width="100%" align="center"
              style="width: 100%; max-width: 320px; display: inline-block; vertical-align: top; margin: 0 auto;">
              <tr>
                <td class="single-listing-stacked-body" style="padding: 0 15px; font-size: 14px; text-align: left;">
                  {{#if ../showAddress}}<h3
                    style="font-size: {{../titleFontSize}}; color: {{../listingAddressColor}}; margin: 0 0 10px; padding: 0; font-weight: bold; word-wrap: break-word;">
                    <a href="{{../href}}" style="display: block; text-decoration: none; color: inherit;">{{{{raw}}}}{{address}}<br />{{city}}, {{stateProvince}} {{postalCode}}{{{{/raw}}}}</a></h3>{{/if}}
                  {{#if ../showPrice}}<p
                    style="font-size: {{../priceFontSize}}; color: {{../listingPriceColor}}; margin: 0 0 10px; padding: 0; font-weight: bold; word-wrap: break-word;">
                    {{{{raw}}}}{{listPrice}}{{{{/raw}}}}</p>{{/if}}
                  {{#if ../showDetails}}<p
                    style="font-size: {{../addressFontSize}}; color: {{../listingDetailsColor}}; margin: 0 0 15px; padding: 0; word-wrap: break-word;">
                    {{{{raw}}}}{{beds}}{{{{/raw}}}} beds • {{{{raw}}}}{{baths}}{{{{/raw}}}} baths •
                    {{{{raw}}}}{{sqFoot}}{{{{/raw}}}} sq ft</p>{{/if}}
                  <table class="single-listing-stacked-button" role="presentation" cellspacing="0" cellpadding="0"
                    border="0" style="margin: 0;">
                    <tr>
                      <td height="40" bgcolor="{{../buttonColor}}" style="height: 40px; border-radius: 4px; background-color: {{../buttonColor}}; text-align: center; padding: 0 20px; mso-padding-alt: 0 20px 0 20px;">
                        <a href="{{../href}}"
                          style="display: block; height: 40px; color: {{../buttonTextColor}}; text-decoration: none; font-weight: bold; font-size: {{../buttonFontSize}}; line-height: 40px; mso-line-height-rule: exactly; white-space: nowrap;"><span style="color: {{#if ../buttonTextColor}}{{../buttonTextColor}}{{else}}#ffffff{{/if}};">{{#if ../buttonText}}{{../buttonText}}{{else}}More Info{{/if}}</span>
												</a>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            <!--[if mso]>
</td>
</tr>
</table>
<![endif]-->
          </td>
        </tr>
      </table>{{/each}}</td>
  </tr>
</table>
<!--[if mso]>
</tr>
</table>
<![endif]-->
			`,
		},
		{
			name: 'Card Layout',
			id: 'card',
			previewImage: 'https://placehold.co/200x150/e1e1e1/666666?text=Card+Layout',
			data: String.raw`
<table class="{{cssClasses}}"{{{listingRefAttr}}} role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="max-width: 600px; margin: 0; background-color: {{backgroundColor}}; font-size: 14px;">
<tr>
<td style="padding: {{padding}}; vertical-align: middle; font-size: 14px; line-height: normal;">{{#each listings}}<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: #ffffff; border-radius: 8px; margin-bottom: 15px;">
<tr>
<td style="padding: 15px;">
<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
<tr>
<td style="text-align: center;">
<a href="{{../href}}" style="display: block; text-decoration: none;">
<img src="{{{{raw}}}}{{imagePath}}{{{{/raw}}}}" alt="Listing Image" width="570" style="width: 100%; max-width: 570px; height: auto; border-radius: 8px; display: block; margin: 0 auto;"/>
</a>
</td>
</tr>
<tr>
<td height="20" style="height: 20px; font-size: 1px; line-height: 1px;">&nbsp;</td>
</tr>
<tr>
<td style="text-align: center;">{{#if ../showAddress}}<h3 style="text-align: center; font-size: {{../titleFontSize}}; color: {{../listingAddressColor}}; margin: 0 0 10px; padding: 0; font-weight: bold;"><a href="{{../href}}" style="display: block; text-decoration: none; color: inherit;">{{{{raw}}}}{{address}}<br/>{{city}}, {{stateProvince}} {{postalCode}}{{{{/raw}}}}</a></h3>{{/if}}
{{#if ../showPrice}}<p style="text-align: center; font-size: {{../priceFontSize}}; color: {{../listingPriceColor}}; margin: 0 0 10px; padding: 0; font-weight: bold;">{{{{raw}}}}{{listPrice}}{{{{/raw}}}}</p>{{/if}}
{{#if ../showDetails}}<p style="text-align: center; font-size: {{../addressFontSize}}; color: {{../listingDetailsColor}}; margin: 0 0 15px; padding: 0;">{{{{raw}}}}{{beds}}{{{{/raw}}}} beds • {{{{raw}}}}{{baths}}{{{{/raw}}}} baths • {{{{raw}}}}{{sqFoot}}{{{{/raw}}}} sq ft</p>{{/if}}
<table role="presentation" cellspacing="0" cellpadding="0" border="0" align="center">
<tr>
<td height="40" bgcolor="{{../buttonColor}}" style="height: 40px; border-radius: 4px; background-color: {{../buttonColor}}; text-align: center; padding: 0 20px; mso-padding-alt: 0 20px 0 20px;">
<a href="{{../href}}" style="display: block; height: 40px; color: {{../buttonTextColor}}; text-decoration: none; font-weight: bold; font-size: {{../buttonFontSize}}; line-height: 40px; mso-line-height-rule: exactly; white-space: nowrap;"><span style="color: {{#if ../buttonTextColor}}{{../buttonTextColor}}{{else}}#ffffff{{/if}};">{{#if ../buttonText}}{{../buttonText}}{{else}}More Info{{/if}}</span>
</a>
</td>
</tr>
</table>
</td>
</tr>
</table>
</td>
</tr>
</table>{{/each}}</td>
</tr>
</table>
`,
		},
	];
}

const singleListingLayouts = getSingleListingLayouts();

export default singleListingLayouts;
